<template>
  <div>
    <b-card>
      <ValidationObserver ref="clientTransaction" v-slot="{ handleSubmit }">
        <b-form class="form-top p-4" @submit.prevent="handleSubmit(formSubmit)">
        <b-row>
          <b-col md="6">
            <input-form v-model="clientTransaction.clientTransaction.transaction_value" :name="$t('clientTransactions.transactionValue')" :label="$t('clientTransactions.transactionValue')" :disabled="disableStatus" />
          </b-col>
          <b-col md="6">
            <input-form v-model="clientTransaction.clientTransaction.old_credit" :name="$t('clientTransactions.oldCredit')" :label="$t('clientTransactions.oldCredit')" :disabled="disableStatus" />
          </b-col>

          <b-col md="6">
            <input-form v-model="clientTransaction.clientTransaction.transaction_type" :name="$t('clientTransactions.transactionType')" :label="$t('clientTransactions.transactionType')" :disabled="disableStatus" />
          </b-col>
          <b-col md="6">
            <input-form v-model="clientTransaction.clientTransaction.direction" :name="$t('clientTransactions.direction')" :label="$t('clientTransactions.direction')" :disabled="disableStatus" />
          </b-col>

          <b-col md="6">
            <input-form v-model="clientTransaction.clientTransaction.source_type" :name="$t('clientTransactions.sourceType')" :label="$t('clientTransactions.sourceType')" :disabled="disableStatus" />
          </b-col>
          <b-col md="6">
            <input-form v-model="clientTransaction.clientTransaction.source_id" :name="$t('clientTransactions.sourceId')" :label="$t('clientTransactions.sourceId')" :disabled="disableStatus" />
          </b-col>

          <b-col md="12">
            <input-form v-model="clientTransaction.clientTransaction.userWallet.name" :name="$t('clientWallets.item')" :label="$t('clientWallets.item')" :disabled="disableStatus" />
          </b-col>
        </b-row>
      </b-form>
      </ValidationObserver>
    </b-card>
  </div>
</template>
<script>
import { core } from '../../../../config/pluginInit'
import clientTransactionServices from '../services/clientTransactions'
import ClientTransaction from '../models/ClientTransaction'
import moduleItemMixin from '../../../../Mixins/moduleItemMixin'

export default {
  mixins: [moduleItemMixin],
  data () {
    return {
      clientTransaction: new ClientTransaction()
    }
  },
  mounted () {
    core.index()
  },
  created () {
    if (this.id) {
      clientTransactionServices.findOne(this.id).then(response => {
        this.clientTransaction.fillData(response.data.data)
        this.loading = false
      })
    } else {
      this.loading = false
    }
  }
}
</script>
